'use strict';

var angular = require('angular');
var BRAINTREE_CLIENT_URL = 'https://js.braintreegateway.com/web/3.134.0/js/client.min.js';

/*@ngInject*/
function braintreeSrv($http, $q, $ocLazyLoad, $log) {
	var service = {};
	var loadPromise;

	service.loadJsFile = function(url) {
		var targetUrl = url || BRAINTREE_CLIENT_URL;

		if (window.braintree && window.braintree.client) {
			return $q.when(window.braintree);
		}

		if (!loadPromise) {
			loadPromise = $ocLazyLoad.load(targetUrl).catch(function(error) {
				loadPromise = null;
				return $q.reject(error);
			});
		}

		return loadPromise;
	};

	service.tokenizeCard = function(card, clientTokenFromServer) {
		var deferred = $q.defer();
		var data = {
			number: card.number,
			cardholderName: 'John Smith',
			expirationMonth: card.exp.month,
			expirationYear: card.exp.year,
			cvv: card.cvc
		};

		service.loadJsFile().then(function() {
			window.braintree.client.create({
				authorization: clientTokenFromServer
			}, function(clientError, clientInstance) {
				if (clientError) {
					deferred.reject(clientError);
					return;
				}

				clientInstance.request({
					api: 'clientApi',
					method: 'post',
					endpoint: 'payment_methods/credit_cards',
					data: {
						creditCard: data
					}
				}, function(requestError, response) {
					var creditCard;

					if (requestError) {
						deferred.reject(requestError);
						return;
					}

					creditCard = response && response.creditCards && response.creditCards[0];

					if (!creditCard || !creditCard.nonce) {
						deferred.reject(new Error('Braintree tokenization returned an empty response.'));
						return;
					}

					deferred.resolve(creditCard.nonce);
				});
			});
		}, deferred.reject);

		return deferred.promise;
	};


	return service;
}


module.exports = angular
	.module('braintreeService', [
		require('oclazyload')
	])
	.factory('braintreeSrv', braintreeSrv);
